import axios from 'axios';
import {apolloPlatformAxiosInstance as axiosInstance} from './apolloPlatformAxiosInstance';
import appConfig from '@/config';
import {PaginatedSpherePage} from '@/stores/apolloPlatform/cores/portalNavigation';

/**
 * CMS API
 */

export const apiGetPreviewData = (token: string, content_type: string) => {
  const url = `${appConfig.BACKEND_API}cms/page_preview/`;
  return axios.get(url, {
    params: {token, content_type},
  });
};

export const apiGetCmsPages = (params?: {
  locale?: string;
  slug?: string;
  translation_of?: number;
}): Promise<AxiosResponse<PaginatedSpherePage>> => {
  return axiosInstance.get('cms/pages/', {params});
};

export const apiGetCmsPage = (
  detail_url: string,
  locale?: 'en' | 'nl',
): Promise<AxiosResponse<SpherePage<SpherePageTypePage>>> => {
  return axiosInstance.get(detail_url, {params: {locale}});
};

export const searchCmsPages = (query: string): Promise<AxiosResponse<PaginatedSpherePage>> => {
  return axiosInstance.get('cms/pages/', {params: {search: query.trim().slice(0, 255)}});
};

export const apiGetCmsDashboard = (
  dashboardId?: number,
): Promise<AxiosResponse<PaginatedSphereWidget>> => {
  return axiosInstance.get('cms/dashboard/', {
    params: dashboardId ? {child_of: dashboardId} : undefined,
  });
};
